<div class="tt-component-widget_container" [attr.unique-id]="component().uniqueId">
  <div class="tt-component-widget">
    <div
      class="tt-component-widget_header"
      role="button"
      tabindex="0"
      (click)="toggleExpanded()"
      (keydown.enter)="toggleExpanded()"
      (keydown.space)="$event.preventDefault(); toggleExpanded()">
      <div class="tt-component-widget_header-expand">
        <mat-icon
          class="tt-component-widget_header-expand-icon"
          [class.tt-component-widget_header-expand-icon--expanded]="expanded()"
          [icon]="hasContent() ? 'chevron-down' : 'dot'"
          [iconSize]="16" />
      </div>

      <div class="tt-component-widget_header-left">
        <div
          class="tt-component-widget_header-title"
          ttCommentableElement
          [elementId]="`${component().uniqueId}-title`"
          [widgetId]="widget().uniqueId">
          {{ title() }}
        </div>

        @if (isEditMode()) {
          <div class="tt-component-widget_tags">
            <tt-resource-tag-list [tags]="selectedResourceTags()" (tagRemoved)="removeTag($event)" />
            <button
              #tagTriggerButton
              ttButton
              [emphasis]="'minimal'"
              [size]="'small'"
              [variant]="'secondary'"
              (click)="openTagDropdown($event)">
              <mat-icon [icon]="'plus'" [iconSize]="14" />
              {{ 'ResourceTag.AddTag' | transloco }}
            </button>
          </div>

          <ng-template #addResourceTagsTemplate>
            <tt-add-resource-tags [selectedTags]="selectedResourceTags()" (tagsChanged)="handleResourceTagLocalChanges($event)" />
          </ng-template>
        } @else {
          <tt-resource-tag-list [readonly]="true" [tags]="selectedResourceTags()" />
        }

        @if (guidelineViewService?.isEditImportedGuidelineMode() && (hasLocalChange() || hasDescriptionLocalChange())) {
          <common-chip data-testid="smartbook-chapter_chip-edited" [variant]="'disabled'">
            {{ 'SingleGuidelineManager.ImportedGuideline.Editor.Edited' | transloco }}
          </common-chip>
        }

        <tt-attachments-links-references-tag
          [attachments]="attachments()"
          [isEditImportedMode]="guidelineViewService.isEditImportedGuidelineMode()"
          [isPreviewMode]="guidelineViewService.isPreviewMode()"
          [isUpdateReviewMode]="guidelineViewService.isPublishReviewMode()"
          [links]="widget().links"
          [medicationRequests]="medicationRequests()"
          [optional]="optional()"
          [references]="widget().references" />
      </div>
      <span class="tt-component-widget_header-divider"></span>

      <div class="tt-component-widget_header-actions" [class.tt-component-widget_header-actions--open]="expanded()">
        @if (isEditMode()) {
          <button
            class="tt-component-widget_header-actions-action tt-component-widget_header-actions-button"
            (click)="openAttachmentDialog($event)">
            <mat-icon [icon]="'paperclip'" [iconSize]="14" />
            {{ 'SingleGuidelineManager.ImportedGuideline.Editor.EditAttachments' | transloco }}
          </button>
        }

        <button
          class="tt-component-widget_header-actions-action"
          ttButton
          [class.tt-component-widget_header-actions--on]="isEditMode()"
          [class.tt-component-widget_header-actions-action--on]="isEditMode()"
          [variant]="'transparent'"
          (click)="toggleEditMode($event)">
          <mat-icon [icon]="'pencil'" [iconSize]="14" />
        </button>

        @if (descriptionWidget()?.localChanges) {
          <button
            class="tt-component-widget_header-actions-action"
            ttButton
            [class.tt-component-widget_header-actions-action--disabled]="hasMergeConflict()"
            [class.tt-component-widget_header-actions-action--on]="isCompareMode()"
            [disabled]="hasMergeConflict()"
            [variant]="'transparent'"
            (click)="toggleCompareMode($event)">
            <mat-icon [icon]="'git-compare-arrows'" [iconSize]="14" />
          </button>
        }
      </div>

      @if (tag()) {
        <tt-guideline-update-tag
          class="tt-smartbook-chapter_original-tag"
          [readonly]="!allowEditTags()"
          [tag]="tag()"
          (tagUpdated)="handleTagUpdated($event)" />
      }
    </div>

    <div class="tt-component-widget_content">
      @if (expanded() && descriptionWidget()) {
        <tt-compare-text-widget
          [isCompareMode]="isCompareMode() || mergeConflictStatus() === 'conflict'"
          [mergeConflictStatus]="mergeConflictStatus()"
          [widget]="descriptionWidget()!"
          [(isEditMode)]="isEditMode"
          (isCompareModeChange)="isCompareMode.set($event)"
          (resolveMergeConflict)="isMergeConflictResolved.set(true)"
          (unresolveMergeConflict)="handleUnresolveMergeConflict()" />
      }
    </div>
  </div>

  @if (childrenWidgets().length > 0 && expanded()) {
    <div class="tt-component-widget_children">
      @for (child of childrenWidgets(); track child.uniqueId) {
        <tt-compare-component-widget [widget]="child" />
      }
    </div>
  }
</div>
